
import img0 from './Images/CreateBackupJob.png';
import img1 from './Images/CreateBackupJobDetails-PostgreSQL.png';
import img2 from './Images/ViewBackupJobs.png';
import img3 from './Images/Clickbackupjobdetails-MariaDB.png';
import img4 from './Images/DownloadConfigFileforUpload-PostgreSQL.png';
import img5 from './Images/DeviceVerification.png';
import img6 from './Images/DeviceVerification2.png';
import img7 from './Images/DeviceConsent.png';
import img8 from './Images/PostgreSQL-WindowsTaskScheduler-CreateBasicTaskWizard01.png';
import img9 from './Images/WindowsTaskScheduler-TriggerDaily02.png';
import img10 from './Images/PostgreSQL-WindowsTaskScheduler-TriggerDailyTimeSetting03.png';
import img11 from './Images/WindowsTaskScheduler-Action04.png';
import img12 from './Images/WindowsTaskScheduler-Action-StartaProgram05.png';
import img13 from './Images/PostgreSQL-WindowsTaskScheduler-Action-StartaProgram06.png';
import img14 from './Images/PostgreSQL-WindowsTaskScheduler-Finish07.png';
import img15 from './Images/PostgreSQL-WindowsTaskScheduler-Properties08.png';
import img16 from './Images/PostgreSQL-WindowsTaskScheduler-Result09.png';
import img17 from './Images/ViewBackupJobs.png';
import img18 from './Images/BackupValidataionStatus01-MariaDB.png';
import img19 from './Images/BackupValidataionStatus02-PostgreSQL.png';
  
const content = `# Backup PostgreSQL Databases
## Objective
The objective of the document is to guide OnData customers on how to use the Data Continuity services effectively to achieve data continuity and disaster recovery
readiness. As part of OnData overall data protection solution, the Data Continuity services are used to ensure data availability, integrity and consistency.
The databases are not only being backed up regularly, but also being validated based on customer-defined validation schedules. The OnData Portal provides clear
visibility into your DR readiness, including Restore Time Objective (RTO) and Restore Point Objective (RPO).

The Data Continuity services provide automated database backup and validation for various types of databases, such as Microsoft SQL, PostgreSQL, MySQL, and MariaDB.
If a database is hosted by OnData, the Data Continuity services can be configured through the OnData Portal. If a database is hosted at on-premises location or other
private/public cloud locations, customers can follow this guide to enable and schedule the automated backups and restore validation. All database backups will be
strongly encrypted before being transmitted via HTTPS to OnData, and stay encrypted when stored at immutable storage locations that are isolated for each customer.

## Main Steps
* Create backup job
* Download BackupConfig.ini and PowerShell scripts
* Customized BackupConfig.ini
* Add public IP address to IP whitelist
* Run PowerShell backup scripts
* Schedule automated backup
* View backup and validation status

## Before you begin
The OnData database backup scripts support different types of database backup strategies, including full backup, differential backup, transaction log backup, and
schema-only backup. Such scripts can be scheduled to run at different intervals to achieve your desired RTO and RPO, while minimizing the storage costs for the backups
as well as the amount of network traffic and load to the database server. For more details about the backup types, you may download and read the PowerShell scripts
that are used to automate the backup, encryption and upload process.

## 1. Create Backup Job
### How to create backup job on OnData Portal

   * From the main menu, select "Services" -> "Continuity"

      ![Create Backup Job](${ img0 } 'Create Backup Job')

   * Click "Create Backup Job", enter the Database Name that matches the name of the database that you intend to backup, and provide information on the corresponding
   Database Engine and Engine version. **NOTE:** It is important to have the exact database name, database engine and database engine version.

      ![Create Backup Job Input](${ img1 } 'Create Backup Job')


## 2. Download Backup Configuration File and PowerShell Script for Database Backup
### How to download the BackupConfig.ini file
   * Select "View Backup Jobs" from the Data Continuity Dashboard

      ![ConfigFileforUpload](${ img2 } 'ConfigFileforUpload')

   * Find the backup job and then click on arrow on the right to view the details

      ![ConfigFileforUpload](${ img3 } 'ConfigFileforUpload')

   *  Click on the "Config File for Upload" link to download the BackupConfig.ini file. It contains configuration information that is unique for handling the backup of
   this database.

      ![ConfigFileforUpload](${ img4 } 'ConfigFileforUpload')


### How to download the PowerShell scripts for backing up PostgreSQL databases
* Based on the database engine version, you can download the appropriate PowerShell scripts from the following links.

  [PowerShell Backup Script for PostgreSQL 14 on Linux/Unix](download_res#BackupSolution/PostgreSQL/14/BackupPostgreSQL14-Linux.ps1 'backuppgsql')

  [PowerShell Backup Script for PostgreSQL 14 on Windows](download_res#BackupSolution/PostgreSQL/14/BackupPostgreSQL14-Windows.ps1 'backuppgsql')

  [PowerShell Backup Script for PostgreSQL 13 on Linux/Unix](download_res#BackupSolution/PostgreSQL/13/BackupPostgreSQL13-Linux.ps1 'backuppgsql')

  [PowerShell Backup Script for PostgreSQL 13 on Windows](download_res#BackupSolution/PostgreSQL/13/BackupPostgreSQL13-Windows.ps1 'backuppgsql')

  [PowerShell Backup Script for PostgreSQL 12 on Linux/Unix](download_res#BackupSolution/PostgreSQL/12/BackupPostgreSQL12-Linux.ps1 'backuppgsql')

  [PowerShell Backup Script for PostgreSQL 12 on Windows](download_res#BackupSolution/PostgreSQL/12/BackupPostgreSQL12-Windows.ps1 'backuppgsql')

  [PowerShell Backup Script for PostgreSQL 11 on Linux/Unix](download_res#BackupSolution/PostgreSQL/11/BackupPostgreSQL11-Linux.ps1 'backuppgsql')

  [PowerShell Backup Script for PostgreSQL 11 on Windows](download_res#BackupSolution/PostgreSQL/11/BackupPostgreSQL11-Windows.ps1 'backuppgsql')


## 3. Customize Backup Configuration File

### How to customize BackupConfig.ini

3.1 Sample BackupConfig.ini for PostgreSQL databases

\`\`\`ini
############################################################################################################
# For more information about using this script, please read the documentation 
# at https://us.ondatahub.com/documents/securedb/database_backup/postgresql
############################################################################################################
 
[Config]
# PostgreSQLbinDir: The path to the PostgreSQL command line executables. The default path is '/usr/local/pgsql/bin' on Linux system, and 
# "C:\\Program Files\\PostgreSQL\\13\\bin" on Windows Server.
PostgreSQLbinDir = <Replace with your PostgreSQL bin dir>

# DatabaseName: The exact name of the database that you want to backup
DatabaseName = Sample

# ServerAddress: The server IP address or Full Qualified Domain Name (FQDN) where the database is hosted
ServerAddress = <Server Address, ex. 127.0.0.1>

# Port: The server port that the database uses for connectivity
Port = 5432

# Username: The name of the database user account who has sufficient permission to backup the database
Username = <Replace with your username>

# Password: The password credential of the database user account
Password = <Replace with your password>

# BackupPath: A local folder that has enough disk space to store the backups temporarily. The backups will be deleted by default after they are encrypted
# and uploaded to OnData. OnData recommends to run the backup from a machine other than the database server. If you need to run the backup directly from 
# the database server, OnData recommends to store the backups in a disk drive that is different from where the Postgres data files are located. For example,
# '/var/opt/backup' for Linux system and "C:\\Program Files\\PostgreSQL\\13\\Backup" on Windows Server.
BackupPath = <Replace with your local path>

#############################################################################################################
# The following configurations are maintained by OnData. Please do not edit them.
# DatabaseId: Identifies a customer-specific database. DO NOT EDIT
#############################################################################################################
DatabaseId = 480

\`\`\`

3.2 Description of BackupConfig.ini

The BackupConfig.ini file downloaded from the OnData Portal needs to be updated with your database specific information before it can be used to backup, encrypt
and upload your database. Below describes each line item that needs to be updated. Do not make any changes to the other fields in the same file.
*  DatabaseName: The exact name of the database that you want to backup
*  ServerAddress: The server IP address or Full Qualified Domain Name (FQDN) where the database is hosted
*  Port: The server port that the database uses for connectivity
*  Username: The name of the database user account who has sufficient permission to backup the database
*  Password: The password credential of the database user account. This entry is optional. The script will look for the password of the database user in the following ways sequentially:
   - If a password is specified on the command line with the -p '<password>' option, the password from the command line will be used.
   - If such option does not exist in the command line, the script will search the BackupConfig.ini file for the password.
   - If a password does not exist in the BackupConfig.ini file either, the script will prompt you to enter the password for the database user.
   
*  BackupPath: A local folder that has enough disk space to store the backups temporarily. The backups will be deleted by default after they are encrypted and uploaded to OnData.

   OnData recommends to run the backup from a machine other than the database server. If you need to run the backup directly from the database server, OnData recommends to
   store the backups in a disk drive that is different from where the PostgreSQL data files are located, for example '/var/opt/backup' on Linux system, "C:&bsol;Program Files&bsol;PostgreSQL&bsol;1x&bsol;Backup" on Windows Server.
*  PostgreSQLbinDir: The direction folder of PostgreSQL bin folder including PostgreSQL executable commands, for example usually '/usr/local/pgsql/bin' on Linux system, "C:&bsol;Program Files&bsol;PostgreSQL&bsol;1x&bsol;bin" on Windows Server.

## 4. Add Public IP Address to IP Whitelist
If you are doing schema only backup, you can skip this step. If you would like to upload the database backup files to OnData, the public IP address of the machine that is used to run the PowerShell Backup Script must be added to the IP Whitelist at the OnData 
Portal. You need to find out your public IP address first. One way to find that information is to open a web browser and search with the term "what is my public IP". Once that 
information is available, login to the OnData Portal. Then select **Organization** under **Settings**. On the **IP Whitelist** tab, click on the **"+"** sign to add your public 
IP address to the list.   

## 5. Run PowerShell Backup Script
### How to run PowerShell backup script

5.1 Copy the backup configuration file and the PowerShell script to a machine that has access to the database that you intend to backup.

**NOTE:** You can specify where the BackupConfig.ini file located with a command parameter (the \`-ConfigPath\`) of the BackupPostgreSQL{version}.ps1 file when executing the command.

5.2 PowerShell version 7.1 or above is required to run the PowerShell script. If your machine does not have PowerShell installed yet, please refer to the following links for
installation.
   *  Windows Server: [Installing PowerShell on Windows](https://docs.microsoft.com/en-us/powershell/scripting/install/installing-powershell-core-on-windows?view=powershell-7.1)
   *  Linux Server: [Installing PowerShell on Linux](https://docs.microsoft.com/en-us/powershell/scripting/install/installing-powershell-core-on-linux?view=powershell-7.1)

Example: Commands to install PowerShell 7.1.3 on Ubuntu 20.04

\`\`\`bash
sudo apt-get update
sudo apt-get install -y wget apt-transport-https software-properties-common
sudo wget -q https://packages.microsoft.com/config/ubuntu/20.04/packages-microsoft-prod.deb
sudo dpkg -i packages-microsoft-prod.deb
sudo apt-get update
sudo add-apt-repository universe
sudo apt-get install -y powershell
sudo pwsh
\`\`\`
Example: Commands to upgrade PowerShell to version 7.1.3 on Windows Server 2019

\`\`\`powershell
Windows PowerShell
Copyright (C) Microsoft Corporation. All rights reserved.

PS C:\\Users\\sqladmin> $PSversionTable

Name                           Value
----                           -----
PSVersion                      5.1.17763.1971
PSEdition                      Desktop
PSCompatibleVersions           {1.0, 2.0, 3.0, 4.0...}
BuildVersion                   10.0.17763.1971
CLRVersion                     4.0.30319.42000
WSManStackVersion              3.0
PSRemotingProtocolVersion      2.3
SerializationVersion           1.1.0.1
PS C:\\Users\\sqladmin> iex "& { $(irm https://aka.ms/install-powershell.ps1) } -UseMSI"
VERBOSE: About to download package from
'https://github.com/PowerShell/PowerShell/releases/download/v7.1.3/PowerShell-7.1.3-win-x64.msi'
PS C:\\Users\\sqladmin>
\`\`\`

5.3 Execute backup

* Launch a PowerShell command line.

\`\`\`Bash
sqladmin@postsql13:/var/opt/backup$ pwsh
PowerShell 7.1.3
Copyright (c) Microsoft Corporation.
https://aka.ms/powershell
Type 'help' to get help.

PS /var/opt/backup>
\`\`\`
* Run the backup PowerShell script with the desired backup type.
\`\`\`bash
PS /var/opt/backup>./BackupPostgreSQL13-Linux.ps1 -BackupType f -p '<password>'

\`\`\`

Note: The \`-p '<password>'\` is optional.

The following types of backups are supported:
1. BackupType: f or F   --> Full backup
2. BackupType: s or S   --> Schema only backup

* Specify another location for BackupConfig.ini file.  
You may have noticed in the above example that we didn't specify the location of config file for our script to look up to. So the location of the config file is controlled by \`-ConfigPath\` command parameter, and it defaults to "BackupConfig.ini" when it's been left empty. Then our script will use this parameter to resolve the actual path to the config file: a) if the "ConfigPath" is an absolute path, it's been used directly; b) but if it's a relative path, we will first look under the current working directory of the shell/command line, if we can find a match we will use it; c) otherwise, we will continue the search under the folder where our script file locates.

\`\`\`bash
PS /var/opt/backup> /root/scripts/BackupPostgreSQL13-Linux.ps1 -BackupType f -ConfigPath bk_sln/PetStoreDb.ini -p '<password>'

# 2 possible config file path:
# First: /var/opt/backup/bk_sln/PetStoreDb.ini
#  Then: /root/scripts/bk_sln/PetStoreDb.ini
\`\`\`

Note: Both the \`-ConfigPath bk_sln/PetStoreDb.ini\` and \`-p '<password>'\` are optional.

* Authorize the backup upload request  
When the script starts to run, if it's the first time it gets to run, the script will instruct user to open up a web browser to authenticate and give consent to the backup script, 
so that the script is authorized to upload backup files.  

\`\`\`bash
PS /var/opt/backup> ./BackupPostgreSQL13-Linux.ps1 -BackupType f
PowerShell Version is: 7.1
Using config file: /var/opt/backup/BackupConfig.ini
Can not find stored credential, will have to perform Device Code authentication.

To sign in, use a web browser to open the page https://us.ondatahub.com/device and enter the code 491065954 to authenticate.

\`\`\`  

Open a web browser and navigate to the page https://us.ondatahub.com/device. Enter the code above as the User Code:   

![DeviceVerification](${ img5 } 'DeviceVerification')

You will be prompted to sign into the OnData Portal with your OnData account. Go ahead and sign in.  

![DeviceVerification2](${ img6 } 'DeviceVerification2')  

Once you sign in, you will be prompted to decide whether you would like to provide the consent to run the script. Select "Yes, Allow" to proceed.   

![DeviceConsent](${ img7 } 'DeviceConsent')

Once you provide the consent, you can close the web page and go back to the backup script. There you will be prompted to choose whether to save the authorization result 
so for next time the script runs. If you choose to store the token for reuse, the script will not ask for any intervention when it runs again.  
\`\`\`bash
PS /var/opt/backup> ./BackupPostgreSQL13-Linux.ps1 -BackupType f
PowerShell Version is: 7.1
Using config file: /var/opt/backup/BackupConfig.ini
Can not find stored credential, will have to perform Device Code authentication.

To sign in, use a web browser to open the page https://us.ondatahub.com/device and enter the code 491065954 to authenticate.
Do you wish to store the token for reuse? [y/n]: y

\`\`\`  

5.4 Encrypt and upload backup files

After the backup is created, the backup PowerShell script will automatically encrypt the backup files, and upload those files to OnData. No user action is required for such
activities.

5.5 Clean up backup files

Once the backup files are uploaded to OnData, the backup PowerShell script will automatically clean up the local backup files by default.  

5.6 Scheduled backups

To implement your database backup strategy, you may schedule to run the backup PowerShell scripts with different backup types and at different intervals. For example, you may
schedule a weekly full backup on every Saturday, and a daily differential backup every midnight. For an enhanced RPO, you may schedule one or more log backups during the day.

There are many tools and approaches for scheduling tasks. Below are two examples of using Crontab on Linux and Task Scheduler on Windows. You may choose other software tools
that are used by your organization. Make sure you have manually executed the Backup Script for the first time and chosen to save the credentials; thus when run by automation, the Backup Script will not silently hang forever waiting for authorization.

* Linux Crontab: For more details on how to use Crontab, please refer to [CronHowto](https://help.ubuntu.com/community/CronHowto).  
  An example of scheduling the various types of backups at different intervals with the crontab job scheduler is illustrated below, assuming that "sqladmin" is the user account previously been used to run Backup Script for the first time:

   \`\`\`bash
   sqladmin@postsql13:~$ crontab -e
   
   #
   # Each line defines when and what command to run for the task
   #
   # For example, to backup your home folder
   # at 5 a.m every week with:
   # 0 5 * * 1 tar -zcf /var/backups/home.tgz /home/
   #
   # Notice that tasks will be started based on the cron's system
   # daemon's notion of time and timezones.
   #
   
   30 0 * * 0  pwsh /var/opt/backup/BackupPostgreSQL13-Linux.ps1 -BackupType F
   \`\`\`

   The above crontab jobs will execute the following backup strategy:
   1. Create a full backup daily at 00:30AM every day.


* Windows Task Scheduler: For more details on how to use Windows Task Scheduler, please refer to [Using Windows Task Scheduler](https://docs.microsoft.com/en-us/windows/win32/taskschd/using-the-task-scheduler).  
  An example of scheduling a task named "DailyFullBackup-PostgreSQL-TestDB" with the Windows Task Scheduler to perform a daily full backup is illustrated below.

  * Open Windows Task Scheduler and Click "Create a Basic Task"

      ![CreateBasicTaskWizard](${ img8 } 'CreateBasicTaskWizard')

  * Select Daily

      ![CreateBasicTaskWizard](${ img9 } 'CreateBasicTaskWizard')

  * Set the Start Time

      ![CreateBasicTaskWizard](${ img10 } 'CreateBasicTaskWizard')

  * Start a Program

      ![CreateBasicTaskWizard](${ img11 } 'CreateBasicTaskWizard')

  * Browse and Choose the Program pwsh.exe (Version 7 or above)

      ![CreateBasicTaskWizard](${ img12 } 'CreateBasicTaskWizard')

  * Add Arguments
    (-ExecutionPolicy ByPass -File F:&bsol;BackupScripts&bsol;PostgreSQL&bsol;BackupPostgreSQL13-Windows.ps1 -BackupType F )

      ![CreateBasicTaskWizard](${ img13 } 'CreateBasicTaskWizard')

  * Click Finish

      ![CreateBasicTaskWizard](${ img14 } 'CreateBasicTaskWizard')

  * Save UserName/Password and Click OK  
      Choose "Run whether user is logged on or not" and save username/password, so the script can access its credentials. The user account should be the same one been used to run Backup Script for the first time.

      ![CreateBasicTaskWizard](${ img15 } 'CreateBasicTaskWizard')

  * View the Scheduled Tasks

      ![CreateBasicTaskWizard](${ img16 } 'CreateBasicTaskWizard')

* Concurrent Backup Automation is not supported  
  > __Caveats:__  
  >   The Backup Script will update its credentials stored on the host machine, and it has exactly only one copy. We cannot guarantee safety under concurrent scripts execution scenarios. As the user, you should have proper arrangement to your backup jobs on the same machine, and make sure they don't overlap on execution.

5.7 Check backup status at OnData Portal

Once the backups have been scheduled, you can follow the steps below to check the backup status at the OnData Portal.

   * Select the "View Backup Jobs" button from the Data Continuity Dashboard

      ![ViewBackupJobs](${ img17 } 'ViewBackupJobs')

   * Find the backup job and then click on the arrow on the right to view details

      ![ViewBackupJobs](${ img18 } 'ViewBackupJobs')

   * View the database backup status and validation status. On the same page, you may configure the restore validation schedule and set your backup retention schedule.

      ![ViewBackupJobs](${ img19 } 'ViewBackupJobs')

`
  
export default content;
